import { DEFAULT_TEMPLATE_THUMB, resolveCdpAsset } from '@/utils/platformHelpers';

export function isImageAssetUrl(url = '') {
  const value = String(url).trim();
  return /\.(png|jpe?g|gif|webp|svg|bmp)(\?|#|$)/i.test(value) || /^data:image\//i.test(value);
}

export function isPdfAssetUrl(url = '') {
  return /\.pdf(\?|#|$)/i.test(String(url).trim());
}

/** 占位 SVG / PDF / 空值不能当封面，否则会挡住首帧提取结果 */
export function isUsableTemplateCover(value) {
  const raw = String(value || '').trim();
  if (!raw || raw === DEFAULT_TEMPLATE_THUMB) return false;
  if (isPdfAssetUrl(raw)) return false;
  if (/^data:image\/svg/i.test(raw)) return false;
  if (raw.length < 12000 && /模版设计稿预览/.test(safeDecode(raw))) return false;
  if (/^data:image\//i.test(raw)) return true;
  if (/^https?:\/\//i.test(raw) || /^blob:/i.test(raw)) return true;
  return isImageAssetUrl(raw);
}

function safeDecode(value) {
  try {
    return decodeURIComponent(value);
  } catch {
    return value;
  }
}

/** 解析模版封面来源：优先 coverThumbUrl/thumb；originFileUrl 仅图片可作为封面 */
export function resolveTemplateThumbSource(tpl = {}) {
  const thumb = String(tpl.coverThumbUrl || tpl.thumb || '').trim();
  if (isUsableTemplateCover(thumb)) return thumb;
  const origin = String(tpl.originFileUrl || '').trim();
  if (origin && isImageAssetUrl(origin) && !isPdfAssetUrl(origin)) return origin;
  return '';
}

export function resolveTemplateThumbUrl(tpl = {}) {
  const source = resolveTemplateThumbSource(tpl);
  if (!source) return DEFAULT_TEMPLATE_THUMB;
  if (/^(https?:|data:|blob:)/i.test(source)) return source;
  return resolveCdpAsset(source);
}
